import { Navigate, useLocation } from 'react-router';

type Props = {
  from: string;
  to: string;
};

/* Blindly replace a string with another string in the pathname and redirect */
export const ReplaceAndRedirect = ({ from, to }: Props) => {
  const { pathname, search, hash } = useLocation();
  const newPath = pathname.replace(from, to);
  return <Navigate to={`${newPath}${search}${hash}`} replace />;
};
